export default "__VITE_ASSET__wyRxKoCv__"